export enum ConnectionType {
  CLOSURE,
  MANUAL,
  TREE,
  ASYNC,
}
